import React from 'react';
import { SectionHeading } from '../SectionHeading';
import { WorkCard } from './WorkCard';
import { workItems } from '../../data/work';
export function SelectedWork() {
  return <section id="work" className="mt-24 scroll-mt-24 lg:scroll-mt-10" data-id="element-367" data-mp="3umzi3wb7sjgc">
      <SectionHeading index="01" label="Case studies" title="Selected work" data-id="element-368" data-mp="3upbza795epsc" />
      <div className="mt-10 space-y-8" data-id="element-369" data-mp="3qn8m9e6tzd4y">
        {workItems.map(item => <WorkCard key={item.id} item={item} data-id="element-370" data-mp="r5hanpzctegg" />)}
      </div>
    </section>;
}